import { DateTime } from "@bps/date-time";
import { nameOfFactory } from "@libs/utils/name-of.utils.ts";
import { TimeRanges } from "@stores/booking/models/TimeRanges.ts";
import { TimeRangesOrgUnit } from "@stores/booking/models/TimeRangesOrgUnit.ts";
import { UserAvailability } from "@stores/booking/models/UserAvailability.ts";
import { User } from "@stores/core/models/User.ts";

export enum AwayChoice {
  away = "away",
  present = "present"
}
export type EditUserDayWorkingHoursFormValues = {
  date?: Date | undefined;
  orgUnitId?: string | undefined;
  startTime?: string | undefined;
  endTime?: string | undefined;
  awayChoice: AwayChoice;
  reason?: string | undefined;
};

export type EditUserDayWorkingHoursProps = {
  user: User;
  onClose: () => void;
};

export type WorkingHoursInfo = {
  start: DateTime | undefined;
  end: DateTime | undefined;
  date: DateTime;
};

export type EditUserDayWorkingHoursData = {
  availability: UserAvailability;
  user: User;
  workingHours?: TimeRangesOrgUnit;
  orgUnitHours?: TimeRanges;
};

export const nameOf = nameOfFactory<EditUserDayWorkingHoursFormValues>();
